module.exports = __webpack_public_path__ + "assets/img/4755-bf.svg";